import { render, staticRenderFns } from "./add-project.vue?vue&type=template&id=38f9423f&scoped=true&"
import script from "./add-project.vue?vue&type=script&lang=js&"
export * from "./add-project.vue?vue&type=script&lang=js&"
import style0 from "./add-project.vue?vue&type=style&index=0&id=38f9423f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f9423f",
  null
  
)

export default component.exports